/**
 * The height of the tooltip's arrow in pixels.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    arrowHeight: function() {
        return arrowHeight;
    },
    tooltipBorderRadius: function() {
        return tooltipBorderRadius;
    }
});
const arrowHeight = 6;
const tooltipBorderRadius = 4;
